import { Injectable } from 'framework/di';

@Injectable
export class RecentlyViewedProductService {
  LOCAL_STORAGE_KEY = 'boostSDRecentlyViewedProduct';
  MAX_RECENTLY_VIEWED_PRODUCTS = 10;

  addRecentlyViewedProduct(productId: string | number): void {
    if (!productId) return;

    const recentlyViewedProducts = this.getRecentlyViewedProducts();
    const updatedProducts = recentlyViewedProducts.filter((id) => id !== productId);

    updatedProducts.unshift(productId.toString());
    if (updatedProducts.length > this.MAX_RECENTLY_VIEWED_PRODUCTS) {
      updatedProducts.pop();
    }

    localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(updatedProducts));
  }

  clearRecentlyViewedProducts(): void {
    localStorage.removeItem(this.LOCAL_STORAGE_KEY);
  }

  getRecentlyViewedProducts(): string[] {
    const storedProducts = localStorage.getItem(this.LOCAL_STORAGE_KEY);
    if (storedProducts) {
      return JSON.parse(storedProducts);
    }
    return [];
  }
}
